import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.5 13.25c.69 0 1.25.56 1.25 1.25v4c0 .69-.56 1.25-1.25 1.25h-4c-.69 0-1.25-.56-1.25-1.25v-4c0-.69.56-1.25 1.25-1.25zm-3.75 5h3.5v-3.5h-3.5zM18.5 13.25c.69 0 1.25.56 1.25 1.25v4c0 .69-.56 1.25-1.25 1.25h-4c-.69 0-1.25-.56-1.25-1.25v-4c0-.69.56-1.25 1.25-1.25zm-3.75 5h3.5v-3.5h-3.5zM9.5 4.25c.69 0 1.25.56 1.25 1.25v4c0 .69-.56 1.25-1.25 1.25h-4c-.69 0-1.25-.56-1.25-1.25v-4c0-.69.56-1.25 1.25-1.25zm-3.75 5h3.5v-3.5h-3.5zM18.5 4.25c.69 0 1.25.56 1.25 1.25v4c0 .69-.56 1.25-1.25 1.25h-4c-.69 0-1.25-.56-1.25-1.25v-4c0-.69.56-1.25 1.25-1.25zm-3.75 5h3.5v-3.5h-3.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }